module.exports = __webpack_public_path__ + "static/media/window-symbol.d1bbc925.svg";